import { render } from "./CollectionList.vue?vue&type=template&id=55e33b6c"
import script from "./CollectionList.vue?vue&type=script&lang=js"
export * from "./CollectionList.vue?vue&type=script&lang=js"

import "./CollectionList.vue?vue&type=style&index=0&id=55e33b6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__